import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { VertexType } from 'src/app/models/VertexType';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { HttpClient } from '@angular/common/http';
import { ImportVertexDTO } from 'src/app/models/importVertexDTO';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { CoordpointidStatusComponent } from '../coordpointid-status/coordpointid-status.component';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { PointsService } from 'src/app/services/points.service';

@Component({
  selector: 'app-vertex-type-selection',
  templateUrl: './vertex-type-selection.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class VertexTypeSelectionComponent implements OnInit {

  @Input()
  vertexTypeMap: Map<string, VertexType[]>;

  @Input()
  vertexTypeRowExpanded: boolean[];

  @Input()
  formData: FormData

  @Input()
  importAerodromes: boolean = false;

  @Input()
  isEad51: boolean = false;

  fileDataSource: string = "published";

  

  constructor(public bsModalRef: BsModalService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public confirmationModal : ModalConfirmationService,
    private modalService: ModalControlService,
    private uiBlock: UiBlockService,
    private pointsController: PointsService) { }



  ngOnInit(): void {
  }

  cancel():void{
    this.bsModalRef.hide();
  }

  static createVertexTypeMap( vertexTypeList:VertexType[]): Map<string, VertexType[]>{
    const vertexTypeMap = new Map<string, VertexType[]>();
    for (const vertexType of vertexTypeList){
      vertexType.selected = false;
      if (vertexTypeMap.has(vertexType.codeType)){
        vertexTypeMap.get(vertexType.codeType).push(vertexType as VertexType);
      } else {
        vertexTypeMap.set(vertexType.codeType, [vertexType as VertexType]);
      }
    }
    return vertexTypeMap;
  }

  static createRowActiveProperty(map: Map<string, VertexType[]>): boolean[]{
    const toReturn: boolean[] = [];
    map.forEach(() => toReturn.push(false));
    return toReturn;
  }

  colapsableLabelVertexType(index : number): void {
    this.vertexTypeRowExpanded[index] = !this.vertexTypeRowExpanded[index];
  }

  changeSelectedChild(mapKey: string, index: number){
    this.vertexTypeMap.get(mapKey)[index].selected = !this.vertexTypeMap.get(mapKey)[index].selected;
  }

  changeSelectedParent(mapKey: string, event){
    if (event.target.checked){
      this.selectAllParent(mapKey);
    } else {
      this.deselectAllParent(mapKey);
    }
  }

  checkIfAllSelected(mapKey: string): boolean{
    for (const row of this.vertexTypeMap.get(mapKey)){
      if (!row.selected){
        return false;
      }
    }
    return true;

  }

  selectAllParent(mapKey: string){
    for (const row of this.vertexTypeMap.get(mapKey)){
      row.selected = true;
    }
  }

  deselectAllParent(mapKey: string){
    for (const row of this.vertexTypeMap.get(mapKey)){
      row.selected = false;
    }
  }

  proceedWithImport(){
    var vertexSelected = this.getVertexTypeSelected();  
    if (vertexSelected.length == 0){
      this.modalService.showMesssageModal("Error", "Please select items to import.");
      return;
    }
    this.confirmationModal.showMesssageConfirmationModal("Warning!","During the update process the information on GRIT database will be updated.", "OK","Cancel",() => {
      this.cancel();
      const importVertexDTO: ImportVertexDTO = new ImportVertexDTO();
      importVertexDTO.vertexSelected = vertexSelected;
      importVertexDTO.isPublished = this.fileDataSource == "published";
      let importType: ImportFileType;
      this.isEad51? importType = ImportFileType.VERTEX_EAD_51_PHASE2: importType = ImportFileType.VERTEX_EAD_45_PHASE2;
      this.formData.append("importVertexDTO", JSON.stringify(importVertexDTO));
      this.uiBlock.startBlock('Parsing XML file...');
      this.http
        .post(
          this.endpointService.endpointParseImportFileCoordinatePoints + '/' + importType,
          this.formData,
          this.endpointService.httpOptions
        )
        .subscribe((points: CoordinatePointModel[])=>{
          this.uiBlock.stopBlock();
          if(points.length>0){ 
            const bsRef:BsModalRef = this.bsModalRef.show(CoordpointidStatusComponent);
            bsRef.content.coordPoints = CoordpointidStatusComponent.getListWithDuplicates(points);
            bsRef.content.importAerodromes = this.importAerodromes;
            bsRef.content.fileToUpload = this.formData.get('file');
            bsRef.content.modalId = bsRef.id;
          } else {
            this.modalService.showMesssageModal("Warning!", "No Vertexes to Import.");
          }
        },
        (error) => {
          this.uiBlock.stopBlock();
          this.pointsController.handleImportError(error, "XML");
        }
      );
    });
  }


  getVertexTypeSelected(): VertexType[] {
    const toReturn: VertexType[] = [];
    for (const vertexTypes of this.vertexTypeMap.values()){
      for (const row of vertexTypes){
        row.selected? toReturn.push(row): false;
      }
    }
    return toReturn;
  }

  selectAll(){
    for (const key of this.vertexTypeMap.keys()){
      this.selectAllParent(key);
    }
  }

  deselectAll(){
    for (const key of this.vertexTypeMap.keys()){
      this.deselectAllParent(key);
    }
  }

}
